<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429988476_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span><strong class="b">D</strong>eepest thanks to my editor, Stacy Hague-Hill, who saw potential in my jumble of a book and knew what it needed: You rock! And to agent extraordinaire Marlene Stringer, for faith, tenacity, and endless patience: You rock, too.</span></div>
<div class="p-indent"><span>To Dianne, my alpha reader, who keeps me real; to Debbie, my staunch advocate, who keeps me sane; to Larry, without whose encouragement DJ would never have seen daylight; to Susan, creator of mojo bags and one fine writer; to Mom, whose willingness to take on the “varmints” allowed me time to write; and to all those who read this in various stages of disarray and still speak to me: Nancy, Stella, Lauri, Amanda, Jennifer, Delaine, Pete, Matt K., Shawn, Matt L., and Meg.</span></div>
<div class="p-indent"><span>Any mistakes in this book are mine, especially regarding the legendary people and places with whom I took great liberties.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429988476_ack01.vue?bfcfa478